export default __webpack_public_path__ + "images/b631311032a52ea2e69c18d557b5e503-001-water.svg";